import { useState, useEffect } from 'react'
import { toastTimeout } from '../../common/constants'
import { AppHeader, LoadingView, Toast } from '../../common/components'
import { useEmployeeList, useEmployeeProfile, useOfficeSelection } from '../../common/hooks'
import EmployeeList from './EmployeeList'
import GroupBooking from './GroupBooking'
import ManageSeat from './ManageSeat'
import './index.css';
import DeleteConfirmation from './DialogBox/DeleteConfirmation'
import EmployeeFormDialog from './DialogBox/EmployeeFormDialog'

const toastInitialState = { show: false, message: '' }

function AdminView({ isOps }) {
  useEffect(() => {
    document.title = 'Admin';
  }, []);

	const
		[employeeList, requestEmployeeList] = useEmployeeList(),
		[removeStatus, addEmployee, updateEmployee, removeEmployee] = useEmployeeProfile(),
		[selectedEmployee, setSelectedEmployee] = useState(null),
		[toast, setToast] = useState(toastInitialState),
		hideEmployeeForm = () => setSelectedEmployee(null),
		[showDeleteDialog, setDeleteDialog] = useState(false),
		[showEmployeeFormDialog, setEmployeeFormDialog] = useState(false),
		[showGroupBooking, setShowGroupBooking] = useState(false),
		[showManageSeat, setShowManageSeat] = useState(false),
		[offices] = useOfficeSelection(),
		normalizeRolePayload = (employee) => ({
			...employee,
			team: (employee?.team || 'user').toLowerCase() === 'ops' ? 'ops' : 'user',
		})

    const
			createToastTimeout = () => setTimeout(() => setToast(toastInitialState), toastTimeout),
			handleError = (error) => setToast({
				show: true,
				message: <>Error removing employee: <span className="text-red-600">{error.message}</span>.</>
			}),
			handleCreate = (employee) => {
				const normalizedEmployee = normalizeRolePayload(employee)
				addEmployee(normalizedEmployee).then(
					() => {
						hideEmployeeForm()
						setToast({
							show: true,
							message: <>New employee '<strong>{normalizedEmployee.fullName}</strong>'' created!</>
						})
						requestEmployeeList()
					},
					handleError
				).finally(createToastTimeout);
				setEmployeeFormDialog(!showEmployeeFormDialog);
			},
			handleUpdate = (employee) => {
				const normalizedEmployee = normalizeRolePayload(employee)
				updateEmployee(normalizedEmployee).then(
					() => {
						requestEmployeeList()
						setSelectedEmployee(null)
						setToast({
							show: true,
							message: <>Employee '<strong>{normalizedEmployee.fullName}</strong>'' updated!</>
						})
						requestEmployeeList()
					},
					handleError
				).finally(createToastTimeout);
				setEmployeeFormDialog(!showEmployeeFormDialog);
			},

			handleRemoveConfirmation = () => {
				removeEmployee(selectedEmployee).then(
					() => {
						setSelectedEmployee(null)
						setToast({
							show: true,
							message: <>Employee '<strong>{selectedEmployee.fullName}</strong>' removed!</>
						})
						requestEmployeeList()
					},
					handleError
				).finally(createToastTimeout);
				setDeleteDialog(!showDeleteDialog);
			},
			handleDeleteDialogModal = (employee) => {
				setDeleteDialog(!showDeleteDialog);
				setSelectedEmployee(employee);
			},
			handleEmployeeFormDialog = (employee) => {
				if(employee == null){
				setSelectedEmployee(null);
				}
				else{setSelectedEmployee(employee);
				}
				setEmployeeFormDialog(!showEmployeeFormDialog);
			},
      handleToast = (message) => {
        setToast({
          show: true,
          message:message
        })
        createToastTimeout();
      }
        
     return !isOps ? <LoadingView /> : (
			<>
				<AppHeader isOps={isOps} />
				<EmployeeList
					data={employeeList}
					onItemClick={handleEmployeeFormDialog}
					onAddClick={handleEmployeeFormDialog}
					onRemoveClick={handleDeleteDialogModal}
					onGroupReservation={() => setShowGroupBooking(true)}
					onManageSeats={() => setShowManageSeat(true)}
				/>
				<DeleteConfirmation employee={selectedEmployee} onConfirm={handleRemoveConfirmation} show={showDeleteDialog} hideModal={handleDeleteDialogModal}/>
				<EmployeeFormDialog employee={selectedEmployee} show={showEmployeeFormDialog} onClose={handleEmployeeFormDialog} onSubmit={handleCreate} onUpdate={handleUpdate}/>
				<GroupBooking isOps={isOps} show={showGroupBooking} onClose={() => setShowGroupBooking(false)} data={offices} handleToast={handleToast} />
				<ManageSeat show={showManageSeat} onClose={() => setShowManageSeat(false)} data={offices} handleToast={handleToast} />
				{removeStatus.isLoading && <LoadingView />}
				<Toast visibility={toast.show}>{toast.message}</Toast>
			</>
    )
}

export { AdminView }
